/**
 * 바우처 서비스
 */

import apiClient from './api';
import { Voucher, VoucherFilter, VoucherListResponse } from '../types/voucher';

export const voucherService = {
  /**
   * 바우처 목록 조회
   */
  async getVouchers(filter: VoucherFilter = {}): Promise<VoucherListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.date_from) params.append('date_from', filter.date_from);
    if (filter.date_to) params.append('date_to', filter.date_to);
    if (filter.voucher_number) params.append('voucher_number', filter.voucher_number);
    if (filter.voucher_code) params.append('voucher_code', filter.voucher_code);
    if (filter.booking_number) params.append('booking_number', filter.booking_number);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: VoucherListResponse }>(`/admin/vouchers?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      vouchers: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 바우처 상세 조회
   */
  async getVoucher(id: number): Promise<Voucher> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { voucher: Voucher } }>(`/admin/vouchers/${id}`);
    // return response.data.data.voucher;

    throw new Error('Not implemented');
  },

  /**
   * 바우처 검증
   */
  async validateVoucher(voucherCode: string): Promise<Voucher> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { voucher: Voucher } }>('/admin/vouchers/validate', {
    //   voucher_code: voucherCode,
    // });
    // return response.data.data.voucher;

    throw new Error('Not implemented');
  },

  /**
   * 바우처 취소
   */
  async cancelVoucher(id: number, reason?: string): Promise<Voucher> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { voucher: Voucher } }>(`/admin/vouchers/${id}/cancel`, { reason });
    // return response.data.data.voucher;

    throw new Error('Not implemented');
  },

  /**
   * 바우처 이메일 재발송
   */
  async resendEmail(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.post(`/admin/vouchers/${id}/resend-email`);

    throw new Error('Not implemented');
  },
};

